
export enum BookGenre {
  LITERARY_FICTION = 'Literary Fiction',
  MYSTERY = 'Mystery/Thriller',
  SCIFI = 'Science Fiction',
  FANTASY = 'Fantasy',
  HISTORICAL = 'Historical Fiction',
  ROMANCE = 'Romance',
  NON_FICTION = 'Creative Non-Fiction'
}

export enum WritingStyle {
  MINIMALIST = 'Minimalist (Hemingway-esque)',
  LYRICAL = 'Lyrical & Poetic (Woolf-esque)',
  DESCRIPTIVE = 'Richly Descriptive (Dickensian)',
  CONTEMPORARY = 'Sharp & Contemporary (Rooney-esque)',
  EPIC = 'Epic & Grand (Tolkien-esque)',
  STREAM_OF_CONSCIOUSNESS = 'Stream of Consciousness'
}

export interface Character {
  id: string;
  name: string;
  role: string;
  description: string;
  arc: string;
}

export interface WorldItem {
  id: string;
  name: string;
  category: 'Location' | 'Lore' | 'Object' | 'Faction' | 'Other';
  description: string;
}

// --- MUSE AGENT TYPES ---
export type MuseContextType = 'story' | 'chapter' | 'characters' | 'world' | 'brainstorm';

export interface MuseAction {
  type: 'create_character' | 'rewrite_chapter' | 'update_outline';
  data: any; // Dynamic data based on type
  label: string; // "Create Character: Zorg"
  description: string; // "Adds a new villain..."
}

export interface MuseMessage {
  id: string;
  role: 'user' | 'model';
  text: string;
  timestamp: number;
  actionProposal?: MuseAction; // Optional structured action
}

export interface CritiqueItem {
  id: string;
  type: 'pacing' | 'dialogue' | 'description' | 'tone' | 'grammar' | 'other';
  quote: string;
  feedback: string;
  suggestion: string;
}

export interface Chapter {
  id: string;
  number: number;
  title: string;
  summary: string; // The planned content
  content: string; // The actual written text
  isDrafted: boolean;
}

export interface BookProject {
  id: string;
  title: string;
  synopsis: string;
  genre: string; // Changed to string to allow custom
  style: string; // Changed to string to allow custom
  language: string; // New field
  targetWordCount: number; // New field for estimated length
  tone: string;
  styleGuide?: string; // New field: Derived from reference materials to guide the prose
  worldSetting?: string; // New field: Optional world building context
  characters: Character[];
  worldBible: WorldItem[]; // New Field
  outline: Chapter[];
  museHistory: MuseMessage[]; // New Field
  createdAt: number;
  lastModified: number;
}

export type ViewMode = 'landing' | 'projects' | 'setup' | 'dashboard';
export type DashboardTab = 'outline' | 'characters' | 'world' | 'write' | 'settings';
export type ThemeMode = 'light' | 'dark' | 'sepia';

export interface AppState {
  projects: BookProject[]; // List of all projects
  currentProjectId: string | null; // Currently active project ID
  viewMode: ViewMode;
  themeMode: ThemeMode;
  activeTab: DashboardTab;
  activeChapterId: string | null;
}